import gsap from "gsap"
import { useEffect, useRef, useState } from "react"
import { numberFixed } from "@/helpers/numberFixed"
import { IUseAnimatedNumberOptions } from "."

export function useAnimatedNumber(
  value: number = 0,
  opts: IUseAnimatedNumberOptions = {}
) {
  const { duration = 0.6, ease = "power2.out", fractionDigits = 0 } = opts

  const [animated, setAnimated] = useState<number>(value)
  const currentRef = useRef<number>(value)

  useEffect(() => {
    const obj = { v: currentRef.current }
    gsap.killTweensOf(obj)

    const tween = gsap.to(obj, {
      v: value,
      duration,
      ease,
      onUpdate: () => {
        currentRef.current = obj.v
        const rounded = numberFixed(obj.v, fractionDigits)
        setAnimated(rounded)
      }
    })

    return () => {
      tween.kill()
    }
  }, [value, duration, ease, fractionDigits])

  return animated
}
